import React, { PureComponent } from 'react';
import './ListDropdown.module.css';

export default class ListDropdown extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  toggleDropdown(e) {
    if (!this.dropdownContainerRef.contains(e.target)) {
      this.setState({ open: false });
    } else {
      if (this.dropdownListRef && this.dropdownListRef.contains(e.target)) {
        return;
      } else {
        this.setState({ open: !this.state.open });
      }
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.toggleDropdown, false);
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.toggleDropdown, false);
  }

  render() {
    const { title, children } = this.props;
    const { open } = this.state;
    return (
      <div
        styleName="list-dropdown"
        tabIndex="0"
        aria-expanded={open}
        role="button"
        aria-label="section navigation"
        ref={container_node => (this.dropdownContainerRef = container_node)}
      >
        <span role="button" styleName="dropdown-button">
          {title}
          <i className="fl-triangle" />
        </span>
        {open && (
          <nav
            styleName="dropdown-items"
            ref={ul_node => (this.dropdownListRef = ul_node)}
          >
            {children.map(item => {
              if (item.button !== 'true') {
                return (
                  <a
                    tabIndex="0"
                    role="button"
                    href={item.url}
                    onClick={() => (window.location = item.url)}
                  >
                    {item.name}
                  </a>
                );
              } else {
                return null;
              }
            })}
          </nav>
        )}
      </div>
    );
  }
}
